exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "dynamic-form {\r\n    display: block;\r\n    margin-top: 20px;\r\n    margin-bottom: 54px;\r\n    padding: 15px;\r\n    padding-left: 20%;\r\n    padding-right: 20%;\r\n    border: 1px solid #ddd;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/admin/dynamic-form.css
// module id = 978
// module chunks = 0